import React, { useEffect, useState } from "react";
import Loadding from "../../components/common/loadding";
import ChangePassword from "../../components/profile/changePassword";
import CreateUser from "../../components/users/createUser";
import DeleteUser from "../../components/users/deleteUser";
import EditUser from "../../components/users/editUser";
import userService from "../../services/user.service";

const Users = () => {
  ////////////
  const [users, setUsers] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [status, setStatus] = useState(true);

  // for Modal   ////////////////////////////////////
  // ดึง users
  useEffect(() => {
    (async () => {
      await userService.getAll().then((res) => {
        // console.log(res);
        const { data } = res;
        setUsers(data);
        setUsersList(data);
        setStatus(false);
      });
    })();
  }, []);

  const handleSearch = (event: any) => {
    // console.log(event.target.value);

    setUsersList(
      users.filter((item: any) => {
        // shortName
        // curriculum.shortName
        // console.log(
        //   item.curriculum.some((d: string) =>
        //     d === event.target.value ? true : false
        //   )
        // );
        // console.log(
        //   item.curriculum.length
        //     ? item.curriculum.filter((d: any) =>
        //         d.shortName.includes(event.target.value)
        //       ).length
        //       ? true
        //       : false
        //     : false
        // );
        // console.log(item.username);
        return (
          item.username.includes(event.target.value) ||
          item.firstName.includes(event.target.value) ||
          item.lastName.includes(event.target.value) ||
          item.tel.includes(event.target.value)
        );
      })
    );
  };

  if (status) {
    return <Loadding />;
  }
  return (
    <>
      <div className="container">
        <h3 className="text-start mt-3">จัดการ Users</h3>
        <div className="row mt-3">
          <div className="col">
            <h3 className="p-3 mb-4 bg-light rounded-4">
              <div className="row">
                <div className="col">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ค้นหาผู้ใช้งาน"
                    aria-label="ค้นหาผู้ใช้งาน"
                    onChange={handleSearch}
                  />
                </div>

                <div className="col-2 d-grid">
                  <CreateUser />
                </div>
              </div>
            </h3>
            <table className="table table-hover table-responsive  table-striped">
              <thead className="table-dark">
                <tr>
                  <th scope="col">Username</th>
                  <th scope="col">ชื่อผู้ใช้งาน</th>
                  <th scope="col">เบอร์โทร</th>
                  <th scope="col">หลักสูตร</th>
                  <th scope="col">สิทธิ์</th>
                  <th scope="col">Handle</th>
                </tr>
              </thead>
              <tbody>
                {usersList.map((user: any) => {
                  return (
                    <tr key={user.id}>
                      <td>{user.username}</td>
                      <td>
                        {user.firstName} {user.lastName}
                      </td>
                      <td>{user.tel}</td>

                      <td>
                        {user.curriculum.map((curri: any) => {
                          return <div key={curri.id}>{curri.shortName}</div>;
                        })}
                      </td>
                      <td>{user.role.name}</td>
                      <td>
                        <EditUser user={user} />
                        <ChangePassword
                          userId={user.id}
                          username={user.username}
                        />
                        <DeleteUser user={user} />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default Users;
